import React from 'react'
import { Link } from 'react-router-dom'

export default function RishikeshAvailability() {
  return (
    <>
    <section className="rishikesh-available">
        <div className="big-container">
            <div className="row">
                
                <div className="col-lg-12">
                    <div className="available-box">
                        <span className='sub-title'>availability</span>

                        <img src="/image/rishikesh-available.webp" loading="lazy" className="img-responsive" alt="availability"/>
                        <div className='available-detail'>
                            <h4>Discover Your Perfect Mountain Sanctuary Today</h4>
                            <div>
                                <p>Discover our exclusive collection of luxurious rooms and premium suites at Resort De Coração Rishikesh.</p>
                                <Link to="/resort-de-coracao-rishikesh/room-listing" className="arrow-butn">Explore Now <img src="/image/right-arrow.svg" alt="arrow" /></Link>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section> 
    </>
  )
}
